__turbopack_context__.v({
  "className": "calibri_5ded4e08-module__h4wvMq__className",
});
